module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "V4039_ebook-3.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "toc_marker-4"
    }
  }, [_c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("HARBOR"), _c('br'), _vm._v("NOCTURNE")])]), _vm._v(" "), _c('p', {
    staticClass: "BTSpace para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-6"
  }, [_vm._v("Joseph Wambaugh")])]), _vm._v(" "), _c('p', {
    staticClass: "BTSpace para-style-override-4"
  }, [_c('span', {
    staticClass: "char-style-override-6"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "mplogo_edited.jpg",
      "height": "46",
      "src": "images/mplogo_edited_fmt.jpeg",
      "width": "49"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-5"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Mysterious Press")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-8"
  }, [_vm._v("an imprint of Grove/Atlantic, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("New York")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b03a9404","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V4039_ebook3.vue
// module id = 69
// module chunks = 0